module.exports = "/_next/static/images/bc38add0ed0d10a0fae2c40aa065b00f-phone.svg";